import * as React from 'react'
import PropTypes from 'prop-types'
import { Button, Drawer, Avatar, Typography, Icon } from 'antd'
import { injectIntl } from 'react-intl'
import EventDetails from '../EventDetails'
import LocationContext from '../../LocationContext'
import './index.css'

const { Text, Title } = Typography

const ListingItem = ({ event, intl }) => {
  const { location, date, title, image } = event
  const [drawerVisible, setDrawerVisible] = React.useState(false)

  return (
    <LocationContext.Consumer>
      {({ toggleDetailOpen }) => (
        <React.Fragment>
          <Button
            onClick={() => {
              toggleDetailOpen()
              setDrawerVisible(true)
            }}
            type="link"
            className="listing-item-button"
            title={intl.formatMessage({
              id: 'listingitem.linktitle',
              defaultMessage: 'Go to details',
            })}
          >
            <div className="listing-item-figure">
              <Avatar src={image} alt={title} size={75} />
            </div>
            <div className="listing-item-text-content">
              <Text
                type="secondary"
                style={{
                  whiteSpace: 'normal',
                  lineHeight: 1.5,
                  display: 'inline-block',
                }}
              >
                {location}, {date}
              </Text>
              <Title level={2}>{title}</Title>
            </div>
            <Icon type="right" />
          </Button>
          <Drawer
            width="100%"
            placement="right"
            closable={false}
            className="event-details-drawer"
            visible={drawerVisible}
            onClose={() => setDrawerVisible(false)}
            keyboard={false}
            destroyOnClose
          >
            <EventDetails
              event={event}
              backFn={() => setDrawerVisible(false)}
            />
          </Drawer>
        </React.Fragment>
      )}
    </LocationContext.Consumer>
  )
}

ListingItem.propTypes = {
  event: PropTypes.object,
  intl: PropTypes.any,
}

export default React.memo(injectIntl(ListingItem))
